import { render, staticRenderFns } from "./EUserDataBloq.vue?vue&type=template&id=71a07af4"
import script from "./EUserDataBloq.vue?vue&type=script&lang=js"
export * from "./EUserDataBloq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports